import Notification from 'Services/Notification/Notification';
export default class ActivityReminderNotification extends Notification {
    constructor(data) {
        super(data);
        this.customizeNotification(data);
    }

    customizeNotification(data) {
        data = data.event_details ?? data;
        this.notif = data;
        this.notif.type = data.linkedObject.type;
        this.onClick = () => {
            const related = data[data.linkedObject.type];
            Activities.openNewActivityDetail(
                data.linkedObject.id,
                related.id,
                related.type,
                null,
                data.linkedObject.type,
            );
        };
    }
}
